/*
 * planiteam-fe
 */

import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService, UserUmanforge } from '@umanforge/common';
import { store } from '@umanforge/common';
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';
import { API } from 'constants/api.contants';
import { GlobalService } from './global.service';
import { AxiosRequestConfig } from 'axios';

export class UserService {
  static async getUsersOfSector(
    sectorId: string,
    token: string | null = null,
    dispatch?: Dispatch,
    onError?: CallbackErrorAxios,
    onWarning?: CallbackWarningAxios
  ): Promise<UserUmanforge[]> {
    const tok = token ?? store.getState().token.value;
    const disp = dispatch ?? store.dispatch;
    const onAxiosWarning = ( response : AxiosResponse ) => { GlobalService.onAxiosWarning( response, onWarning ); };
    const onAxiosError = ( err : AxiosError ) => { GlobalService.onAxiosError( err, disp, onError ); };
    try {
      const config: AxiosRequestConfig = { ...await CommonGlobalService.getHeaderRequest( tok ), params: { sectorsId: [ sectorId ], appName: 'PLANITEAM' } } as AxiosRequestConfig;
      const response = await AXIOS.get( API.USERS + 'by_sectors/', config );
      CommonGlobalService.saveRequestToken( response, disp );
      if ( response.status === 202 ) { onAxiosWarning( response ); }
      if ( response.status === 200 ) { return response.data as UserUmanforge[]; }
      return [];
    } catch ( err ) {
      onAxiosError( err as AxiosError );
      return [];
    }
  }
}
